import { createElement } from 'react';
import { b as __rest, a4 as LinkNavigation$1, _ as __assign } from '../../index.esm-5f955dcb.js';
import 'react-measure';
import 'react-router-dom';
import 'react-dom';
import 'throttle-debounce';
import 'focus-trap-react';
import 'react-swipeable';
import 'react-animate-height';
import 'country-flag-emoji-polyfill';
import 'intersection-observer';
import 'html-react-parser';

var LinkNavigation = function LinkNavigation(_a) {
  var props = __rest(_a, ["iconBrand"]);
  return /*#__PURE__*/createElement(LinkNavigation$1, __assign({
    iconBrand: "uq-ec-"
  }, props));
};
LinkNavigation.displayName = 'LinkNavigation';

export { LinkNavigation };
